import axios from 'axios';
import envConfig from '../../config/env';

 const happinessCheck =  (cid) => {

    //let cid = props.match.params.cid;

    async function axiosGet() {      
      const postRes = await axios.post(`${envConfig.WebAPI}/Happiness`, { oNo: cid, kind:'' });
      //console.log(postRes.data);
      return await postRes.data;

  }
  
  return axiosGet();
  
} 


export default happinessCheck;
